import React from "react"
import PropTypes from "prop-types"
import {Button, FormInput, FormSelect, InputGroup} from "elemental"

const CartActions = ({ cart, product }) => {
  return (
    <InputGroup.Section>
      <Button
        onClick={() => {
          cart.remove( product )
        }}
        className="btn-square"
        type="default"><i className="icon-cancel"/></Button>
    </InputGroup.Section>
  )
}

CartActions.propTypes = {
  cart:    PropTypes.object,
  product: PropTypes.object,
}

const ListActions = ({ list, product }) => {
  return (
    <InputGroup.Section>
      <Button
        onClick={() => {
          list.remove( product )
        }}
        className="btn-square"
        type="default"><i className="icon-cancel"/></Button>
      <Button
        onClick={() => {
          list.toCart( product )
        }}
        className="btn-square"
        type="primary"><i className="icon-cart-plus"/></Button>
    </InputGroup.Section>
  )
}

ListActions.propTypes = {
  list:    PropTypes.object,
  product: PropTypes.object,
}

const ProductQuantityGroup = ({ product, cart, list, index, large, onChange, onAdd }) => {
  const selectedValue = `${product.unit_multi}::${product.unit_id}`
  const veOptions     = product.quantities.map( (qty) => {
    // TODO: The value field is SUPER hack-ish, but Elemental's FormSelect
    // insists on getting a string as value prop. If there's a better idea go ahead.
    return {
      label: qty.des,
      value: `${qty.multi}::${qty.map_desc_id}`
    }
  } )

  return (
    <InputGroup className="ma0"
                contiguous>
      <InputGroup.Section>
        <Button onClick={() => {
          product.count = Math.max( 0, --product.count )
          onChange( { product } )
        }}>-</Button>
      </InputGroup.Section>
      <InputGroup.Section style={{ minWidth: "50px", maxWidth: "80px" }} grow>
        <FormInput
          tabIndex={index}
          onChange={(e) => {
            product.count = Math.max( 0, Number( e.target.value ) )
            onChange( { product } )
          }}
          className="tc"
          type="number"
          value={product.count}
          placeholder="0"/>
      </InputGroup.Section>
      <InputGroup.Section className="mr1">
        <Button onClick={() => {
          ++product.count
          onChange( { product } )
        }}>+</Button>
      </InputGroup.Section>
      <InputGroup.Section className="mr1">
        <FormSelect className="qty-select" style={{ minWidth: "100px" }} options={veOptions} value={selectedValue} onChange={(value) => {
          const qty          = value.split( "::" ) // Sad face.
          product.unit_multi = Number( qty[ 0 ] )
          product.unit_id    = qty[ 1 ]
          onChange( { product } )
        }}/>
      </InputGroup.Section>

      {!large && list ? <ListActions list={list} product={product}/> : null}
      {!large && cart ? <CartActions cart={cart} product={product}/> : null}
      {large && onAdd ? <Button type="primary" onClick={() => {
        if ( product.count === 0 ) product.count = 1
        onAdd( { product } )
      }}><i className="icon-basket"/>{product.count * product.unit_multi} {translate( "product.piece" )}</Button> : null}
    </InputGroup>
  )
}

// props.cart and props.list are marked optional since we need either one or the other.
ProductQuantityGroup.propTypes = {
  product:  PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onAdd:    PropTypes.func,
  cart:     PropTypes.object,
  list:     PropTypes.object,
  index:    PropTypes.number
}

export default ProductQuantityGroup



// WEBPACK FOOTER //
// ./src/components/Product/ProductQuantityGroup.js